import stylesgfi from "./NationalSchoolGames.module.css";
import Breadcrumb from "../../components/common/Breadcrumb";
import useBWKLSchedule from "./hooks/useBWKLSchedule";
import MatchResultCard from "./modules/MatchResultCard";

export default function BiharWomenKabaddiMatchResultsE2() {
  const [schedule] = useBWKLSchedule({ endpoint: "https://bssa-json-server-vercel-deployment.vercel.app/bwkl-e2" });
  return (
    <>
      <Breadcrumb
        pageName={BiharWomenKabaddiMatchResultsE2}
        pageTitle={"BiharWomenKabaddiMatchResultsE2"}
        img_url={"/img/BWKLE2-Desktop.jpeg"}
        mobile_banner="/img/BWKLE2-Mobile.jpeg"
      />
      <div></div>
      <div>
        <h1 className={`${stylesgfi.title}`}>
          द्वितीय बिहार महिला कबड्डी लीग 2026 परिणाम
        </h1>
      </div>

      <div className={`container`}>
        {/* match schedule cards */}
        {(schedule||[]).map((match) => (
          <MatchResultCard
            key={match.matchNumber}
            matchNumber={match.matchNumber}
            teamA={match.teamA}
            teamALogo={match.teamALogo || "/img/कबड्डी.png"}
            teamAScore={match.scoreA||""}
            teamB={match.teamB}
            teamBLogo={match.teamBLogo || "/img/कबड्डी.png"}
            teamBScore={match.scoreB||""}
            time={match.time}
            date={match.date}
            gameStatus={match.gameStatus}
          />
        ))}
      </div>
    </>
  );
}
